import { render } from "./priceOffer.vue?vue&type=template&id=04464b86&scoped=true"
import script from "./priceOffer.vue?vue&type=script&lang=js"
export * from "./priceOffer.vue?vue&type=script&lang=js"

import "./priceOffer.vue?vue&type=style&index=0&id=04464b86&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04464b86"]])

export default __exports__